import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { mb, mt } from "styled-components-spacing"
import tick from "../../images/tick-black-fat.svg"

export const UL = styled.ul`
  padding-left: ${props => (props.indented ? "40px" : "1em")};
  ${props => mb(props.mb)};
  li {
    list-style: none;
    ${props => (props.liMb !== undefined ? mb(props.liMb) : ``)};

    :last-child {
      margin-bottom: 0;
    }

    :before {
      content: "\\2022";
      color: ${props => {
        if (props.liColor) {
          return props.theme.colors[props.liColor] || props.liColor
        }
        return `currentColor`
      }};

      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
  }
`
UL.propTypes = {
  indented: PropTypes.bool,
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  liMb: PropTypes.oneOfType([PropTypes.number, PropTypes.object]), // margin on li
  liColor: PropTypes.string,
}
UL.defaultProps = {
  indented: true,
  mb: 0,
  liMb: 0,
}

export const P = styled.p`
  ${props =>
    props.noMt &&
    css`
      margin-top: 0;
    `}
  ${props =>
    props.noMb &&
    css`
      margin-bottom: 0;
    `}
  
  ${props => props.mt !== undefined && mt(props.mt)}
  ${props => props.mb !== undefined && mb(props.mb)}
  ${props =>
    props.centered &&
    css`
      text-align: center;
    `}
`

P.defaultProps = {
  mt: 0,
  mb: 2,
}

P.propTypes = {
  centered: PropTypes.bool,
  noMt: PropTypes.bool,
  noMb: PropTypes.bool,
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  mt: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
}
export const TickLi = styled.li`
  background: url("${tick}") 0 8px no-repeat;
  background-size: 13px;
  list-style: none;
  padding-left: 20px;
`
